import { formatDistanceToNow, isToday, isYesterday } from "date-fns";
export class ProjectFilesStorageModel {
    constructor() {
        this.name = "";
        this.url = "";
        this.employeeName = "";
    }
    formatTime() {
        const parsedDate = new Date(this.uploadedOn);
        if (isToday(parsedDate)) {
            return formatDistanceToNow(parsedDate, { addSuffix: true, includeSeconds: true });
        }
        if (isYesterday(parsedDate)) {
            return "Yesterday";
        }
        return formatDistanceToNow(parsedDate, { addSuffix: true });
    }
}
export default class ProjectsUrlStorage extends ProjectFilesStorageModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
